import
  PropTypes
from 'prop-types';

import {
  CustomContainer,
  Form,
  Col,
} from '../../DependencyHelper';

import
  formStyles
from '../CheckoutForms.module.scss';

import
  SelectDropDown
from '../selectDropDown/SelectDropDown';

const DeliveryAddress = ({
  formName,
  variant,
  validations,
  fieldValues,
  fieldErrors,
  fieldErrorsMessage,
  readOnlyValues,
  addressTypesOptions,
  stateTypesOptions,
  onChangeHandler,
  onBlurHandler,
  containerClassName,
  rowClassName,
  isGuestUser,
}) => {

  const handleChange = (event) => {
    onChangeHandler(event, null, formName);
  };

  const handleBlur = (event) => {
    onBlurHandler(event, null, formName);
  };

  const handleDropdown = (event, val = null, formName) => {
    onChangeHandler(event, val, formName);
    onBlurHandler(event, val, formName);
  };

  return (

    <CustomContainer className={`${formStyles[variant]} ${formStyles['main-container']}  ${containerClassName}`}>

      <Form.Row className={`${formStyles['main-row']} ${rowClassName}`}>

        { formName !== 'companyInformation' &&

          <>
            <Form.Group
              as={Col}
              sm='12'
              md='12'
              className={formStyles['form-group']}
              controlId={`validationFormda101-${variant}-${formName}`}>

                <Form.Label
                  className={formStyles['form-label']}
                  id={`validationFormda101-label-${variant}-${formName}`}>

                    Address type
                </Form.Label>

                <Form.Control
                  type='text'
                  name='addressName'
                  value={fieldValues['addressName']}
                  placeholder='Home address / Work address'
                  onChange={handleChange}
                  onBlur={handleBlur}
                  readOnly={readOnlyValues['addressName']}
                  isInvalid={fieldErrors['addressName']}
                  className={
                    fieldErrors['addressName']
                      ? formStyles['invalid']
                      : ''
                  }
                />

                <Form.Control.Feedback
                  type='invalid'
                  className={formStyles['invalid-feedback']}>

                    { fieldErrorsMessage['addressName'] }
                </Form.Control.Feedback>

                { !fieldErrors['addressName'] &&

                  <div className={formStyles['hint-text']}>
                    What you normally call this address (e.g. Home, Work)
                  </div>
                }
            </Form.Group>
          </>
        }

        <Form.Row className={formStyles['form-row']}>

          <Form.Label
            className={`d-block d-sm-none ${formStyles['form-label']}`}
            id={`validationFormda103-mob-label-${variant}-${formName}`}>

              Unit no. & Complex name

              { !validations['unitNo'] && !validations['complexName'] &&

                <span>
                  { ' (Optional)' }
                </span>
              }
          </Form.Label>

          <Form.Group
            as={Col}
            xs='4'
            sm='4'
            lg='5'
            className={formStyles['form-group']}
            controlId={`validationFormda103-${variant}-${formName}`}>

              <Form.Label
                className={`d-none d-sm-block ${formStyles['form-label']}`}
                id={`validationFormda103-label-${variant}-${formName}`}>

                  Unit no / Floor no

                  { !validations['unitNo'] &&

                    <span>
                      { ' (Optional)' }
                    </span>
                  }
              </Form.Label>

              <Form.Control
                type='text'
                name='unitNo'
                value={fieldValues['unitNo']}
                placeholder='#'
                onChange={handleChange}
                onBlur={handleBlur}
                readOnly={readOnlyValues['unitNo']}
                isInvalid={fieldErrors['unitNo']}
                className={
                  fieldErrors['unitNo']
                    ? formStyles['invalid']
                    : ''
                }
              />

              <Form.Control.Feedback
                type='invalid'
                className={formStyles['invalid-feedback']}>

                  { fieldErrorsMessage['unitNo'] }
              </Form.Control.Feedback>
          </Form.Group>

          <Form.Group
            as={Col}
            xs='8'
            sm='8'
            lg='7'
            className={formStyles['form-group']}
            controlId={`validationFormda104-${variant}-${formName}`}>

              <Form.Label
                className={`d-none d-sm-block ${formStyles['form-label']}`}
                id={`validationFormda104-label-${variant}-${formName}`}>

                  Complex name / Business name

                  { !validations['complexName'] &&

                    <span>
                      { ' (Optional)' }
                    </span>
                  }
              </Form.Label>

              <Form.Control
                type='text'
                name='complexName'
                value={fieldValues['complexName']}
                placeholder='Add complex name or business name'
                onChange={handleChange}
                onBlur={handleBlur}
                readOnly={readOnlyValues['complexName']}
                isInvalid={fieldErrors['complexName']}
                className={
                  fieldErrors['complexName']
                    ? formStyles['invalid']
                    : ''
                }
              />

              <Form.Control.Feedback
                type='invalid'
                className={formStyles['invalid-feedback']}>

                  { fieldErrorsMessage['complexName'] }
              </Form.Control.Feedback>
          </Form.Group>
        </Form.Row>

        <Form.Row className={formStyles['form-row']}>

          <Form.Label
            className={`d-block d-sm-none ${formStyles['form-label']}`}
            id={`validationFormda105-mob-label-${variant}-${formName}`}>

            Street no.
            
            {!validations['streetNo'] && validations['streetName'] &&
              <span>
                {'(Optional) '}
              </span>
            }

            & Street name
          </Form.Label>

          <Form.Group
            as={Col}
            xs='4'
            sm='4'
            lg='5'
            className={formStyles['form-group']}
            controlId={`validationFormda105-${variant}-${formName}`}>

              <Form.Label
                className={`d-none d-sm-block ${formStyles['form-label']}`}
                id={`validationFormda105-label-${variant}-${formName}`}>

                  Street no.

                  { !validations['streetNo'] &&

                    <span>
                      { ' (Optional)' }
                    </span>
                  }
              </Form.Label>
              <Form.Control
                type='text'
                name='streetNo'
                value={fieldValues['streetNo']}
                placeholder='#'
                onChange={handleChange}
                onBlur={handleBlur}
                readOnly={readOnlyValues['streetNo']}
                isInvalid={fieldErrors['streetNo']}
                className={
                  fieldErrors['streetNo']
                    ? formStyles['invalid']
                    : ''
                }
              />

              <Form.Control.Feedback
                type='invalid'
                className={formStyles['invalid-feedback']}>

                  { fieldErrorsMessage['streetNo'] }
              </Form.Control.Feedback>
          </Form.Group>

          <Form.Group
            as={Col}
            xs='8'
            sm='8'
            lg='7'
            className={formStyles['form-group']}
            controlId={`validationFormda106-${variant}-${formName}`}>

              <Form.Label
                className={`d-none d-sm-block ${formStyles['form-label']}`}
                id={`validationFormda106-label-${variant}-${formName}`}>

                  Street name

                  { !validations['streetName'] &&

                    <span>
                      { ' (Optional)' }
                    </span>
                  }
              </Form.Label>

              <Form.Control
                type='text'
                name='streetName'
                value={fieldValues['streetName']}
                placeholder='Add street name'
                onChange={handleChange}
                onBlur={handleBlur}
                readOnly={readOnlyValues['streetName']}
                isInvalid={fieldErrors['streetName']}
                className={
                  fieldErrors['streetName']
                    ? formStyles['invalid']
                    : ''
                }
              />

              <Form.Control.Feedback
                type='invalid'
                className={formStyles['invalid-feedback']}>

                  { fieldErrorsMessage['streetName'] }
              </Form.Control.Feedback>
          </Form.Group>
        </Form.Row>

        <Form.Row className={formStyles['form-row']}>

          <Form.Label
            className={`d-block d-sm-none ${formStyles['form-label']}`}
            id={`validationFormda107-mob-label-${variant}-${formName}`}>

              Suburb & Postal code
          </Form.Label>

          <Form.Group
            as={Col}
            xs='8'
            sm='8'
            lg='7'
            className={formStyles['form-group']}
            controlId={`validationFormda107-${variant}-${formName}`}>

              <Form.Label
                className={`d-none d-sm-block ${formStyles['form-label']}`}
                id={`validationFormda107-label-${variant}-${formName}`}>

                  Suburb
              </Form.Label>

              <Form.Control
                type='text'
                name='suburb'
                value={fieldValues['suburb']}
                placeholder='Add suburb'
                onChange={handleChange}
                onBlur={handleBlur}
                readOnly={readOnlyValues['suburb']}
                isInvalid={fieldErrors['suburb']}
                className={
                  fieldErrors['suburb']
                    ? formStyles['invalid']
                    : ''
                }
              />

              <Form.Control.Feedback
                type='invalid'
                className={formStyles['invalid-feedback']}>

                  { fieldErrorsMessage['suburb'] }
              </Form.Control.Feedback>
          </Form.Group>

          <Form.Group
            as={Col}
            xs='4'
            sm='4'
            lg='5'
            className={formStyles['form-group']}
            controlId={`validationFormda108-${variant}-${formName}`}>

              <Form.Label
                className={`d-none d-sm-block ${formStyles['form-label']}`}
                id={`validationFormda108-label-${variant}-${formName}`}>

                  Postal code
              </Form.Label>

              <Form.Control
                type='text'
                name='postalCode'
                value={fieldValues['postalCode']}
                placeholder='#'
                maxLength='4'
                onChange={handleChange}
                onBlur={handleBlur}
                readOnly={readOnlyValues['postalCode']}
                isInvalid={fieldErrors['postalCode']}
                className={
                  fieldErrors['postalCode']
                    ? formStyles['invalid']
                    : ''
                }
              />

              <Form.Control.Feedback
                type='invalid'
                className={formStyles['invalid-feedback']}>

                  { fieldErrorsMessage['postalCode'] }
              </Form.Control.Feedback>
          </Form.Group>
        </Form.Row>

        <Form.Group
          as={Col}
          sm='12'
          md='12'
          className={formStyles['form-group']}
          controlId={`validationFormda109-${variant}-${formName}`}>

            <Form.Label
              className={formStyles['form-label']}
              id={`validationFormda109-label-${variant}-${formName}`}>

                Town / City
            </Form.Label>

            <Form.Control
              type='text'
              name='town'
              value={fieldValues['town']}
              placeholder='Add town / city'
              onChange={handleChange}
              onBlur={handleBlur}
              readOnly={readOnlyValues['town']}
              isInvalid={fieldErrors['town']}
              className={
                fieldErrors['town']
                  ? formStyles['invalid']
                  : ''
              }
            />

            <Form.Control.Feedback
              type='invalid'
              className={formStyles['invalid-feedback']}>

                { fieldErrorsMessage['town'] }
            </Form.Control.Feedback>
        </Form.Group>

        <Form.Group
          as={Col}
          sm='12'
          md='12'
          className={formStyles['form-group']}
          controlId={`validationFormda110-${variant}-${formName}`}>

            <Form.Label
              className={formStyles['form-label']}
              id={`validationFormda110-label-${variant}-${formName}`}>

                Province
            </Form.Label>

            <SelectDropDown
              formName={formName}
              name='province'
              label='Province'
              data={stateTypesOptions}
              handleSelect={handleDropdown}
              selectedId={fieldValues['province']}
              customId={`validationFormda110-${variant}-${formName}`}
              fieldError={fieldErrors['province']}
            />

        </Form.Group>

        {/*
        Don't delete it we will show it later

        {formName == 'delivery' && status !== 'change' && (
          <Form.Group
            as={Col}
            sm='12'
            md='12'
            className={formStyles['form-group']}
            controlId={`validationFormik111-${variant}-${formName}`}>

            <Form.Label className={formStyles['form-label']} id={`validationFormik111-label-${variant}-${formName}`}>
              Any special instructions? <span>(Optional)</span>
            </Form.Label>
            <Form.Control
              as='textarea'
              name='instructions'
              placeholder='e.g. Please call me when you're at the gate'
              value={fieldValues['instructions']}
              className={formStyles['form-control-area']}
              onChange={handleChange}
              onBlur={handleBlur}
              readOnly={readOnlyValues['instructions']}></Form.Control>

            <div className={formStyles['hint-text']}>
              {'Deliveries are made on weekdays between 08:00 and 17:00'}
            </div>
          </Form.Group>
        )} */}

        { variant !== 'popup' &&
          formName !== 'companyInformation' &&
          !isGuestUser &&

          <Form.Group
            as={Col}
            sm='12'
            md='12'
            className={`${formStyles['form-group']}`}>

              <Form.Check
                custom
                name='futureCheck'
                label='Save this address for future purchases'
                onChange={handleChange}
                onBlur={handleBlur}
                className={formStyles['form-checkbox-label']}
                id={`validationFormik112-${variant}-${formName}`}
              />
          </Form.Group>
        }

        { variant !== 'popup' &&
          formName !== 'companyInformation' &&
          isGuestUser &&

          <Form.Group
            as={Col}
            sm='12'
            md='12'
            className={`${formStyles['form-group']}`}>

              <Form.Check
                custom
                name='contactCheck'
                label='I am the contact person for this address'
                checked={fieldValues['contactCheck']}
                onChange={handleChange}
                onBlur={handleBlur}
                className={formStyles['form-checkbox-label']}
                id={`validationFormik113-${variant}-${formName}`}
              />
          </Form.Group>
        }

      </Form.Row>
    </CustomContainer>
  );
};

DeliveryAddress.propTypes = {
  variant: PropTypes.oneOf(['plain', 'popup']),
  formName: PropTypes.oneOf(['delivery', 'billing', 'companyInformation']),
  status: PropTypes.oneOf(['add', 'edit', 'change']),
  validations: PropTypes.object,
  fieldValues: PropTypes.object,
  fieldErrors: PropTypes.object,
  fieldErrorsMessage: PropTypes.object,
  readOnlyValues: PropTypes.object,
  onChangeHandler: PropTypes.func,
  addressTypesOptions: PropTypes.array,
  stateTypesOptions: PropTypes.array,
  containerClassName: PropTypes.string,
  rowClassName: PropTypes.string,
  isGuestUser: PropTypes.bool,
  onBlurHandler: PropTypes.func,
};

DeliveryAddress.defaultProps = {
  variant: 'plain',
  formName: 'delivery',
  validations: {},
  fieldValues: {},
  fieldErrors: {},
  fieldErrorsMessage: {},
  readOnlyValues: {},
  addressTypesOptions: [],
  stateTypesOptions: [],
  isGuestUser: false,
};

export default DeliveryAddress;
